import React, { useState, useEffect } from 'react';
import Menu from '../../components/Menu';
import api from '../../services/api';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

function Resultado(props){    
    const { search } = useLocation();
    // Função para extrair os parâmetros de consulta da string de consulta
  const getQueryParam = (name) => {
    const params = new URLSearchParams(search);
    return params.get(name);
  };
  const msgUrl = getQueryParam('msg');
    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = './Painel';
        return;
    }

    const [trava, setTrava] = useState(true);
    const [dados, setDados] = useState({});
    const [dadosFaturas, setDadosFaturas] = useState([]);
    useEffect( () => {
        async function getDados(){
            let dados = await api.get('perfil');
            console.log(dados.data);
            if(dados.data.msg === 'token invalido.'){
                window.location = '../Sair';
            }else{    
                if(dados.data === '"null"'){

        
                }else{
                    setTrava(false);
                    setDados(dados.data);
                }
            }
        }

        async function getDadosFaturas(){
            let dados = await api.get('Fatura');
            console.log(dados.data);
            if(dados.data.msg === 'token invalido.'){
                window.location = '../Sair';
            }else{    
                if(dados.data === '"null"'){

        
                }else{
                    setTrava(false);
                    setDadosFaturas(dados.data);
                }
            }
        }
       getDados();
       getDadosFaturas();
    }, [setDados, setDadosFaturas]);
    if(!window.localStorage.getItem('token')){
        window.location = './Sair';
        return;
    }
    return (<div class="main-content" style={{marginLeft: '0'}}>
        <Menu />
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop:'100px'}}>
                    <img src={'../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>
        <>
            <center>
                {msgUrl ? (<div style={{marginLeft: '5%', marginRight: '5%'}} className="alert alert-warning" role="alert">{msgUrl ?? ''}</div>) : ''}
            </center>
        </>
        {trava == false ? <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Dados cadastrais</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '12px'}}>
                        <table id="resultCadastro" class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>Usuario:</strong> {dados.usuario}
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Data Contratacao:</strong> {dados.contratacao}
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Data vencimento:</strong> {dados.vencimento}
                                        
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Valor:</strong> R$: {dados.valor}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Status:</strong> {dados.limite_cpf == 5 ? 'Periodo de teste' : 'Plano mensal'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div> : (``)}

    


    <div class="row" style={{display: 'block'}}>
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Limite/Consumo</a>
                </li>
            </ul>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="table-responsive">
                    <table id="mytable" class="table table-bordred table-striped">
                        <tbody>
                                                                                                     <tr>
                                <td>
                                    <strong>CPF: </strong>
                                    <span id="resultrPlus">{dados.limite_cpf} de {dados.usado_cpf}</span>
                                </td>
                              </tr>
                                                                                                       <tr>
                                <td>
                                    <strong>NOME: </strong>
                                    <span id="resultrPlus">{dados.limite_nome} de {dados.usado_nome}</span>
                                </td>
                              </tr>
                                                                   
                                                                      <tr>
                                  <td>
                                      <strong>TELEFONE/E-MAIL: </strong>
                                      <span id="resultrPlus">{dados.limite_telefone} de {dados.usado_telefone}</span>
                                  </td>
                                </tr>
                                
                                                                      <tr>
                                  <td>
                                      <strong>ENDEREÇO: </strong>
                                      <span id="resultrPlus">{dados.limite_endereco} de {dados.usado_endereco}</span>
                                  </td>
                                </tr>
                                
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" style={{display: 'block'}}>
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" class="active">
                    <a href="#faturas" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Faturas</a>
                </li>
            </ul>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="home">
                <div class="table-responsive">
                    <table id="mytable" class="table table-bordred table-striped">
                    <thead>
                            <tr>
                                <td>ID</td>
                                <td>GATWEY</td>
                                <td>VALOR</td>
                                <td>DATA PAGAMENTO</td>
                                <td>OPÇÕES</td>
                            </tr>
                        </thead>
                        <tbody>
                        {dadosFaturas.map((dado) => {
                            return <tr>
                                <td>{dado.id ?? ''}</td>
                                <td>PIX</td>
                                <td>R$ {dado.valor ?? ''}</td>
                                <td>{moment(dado.data_pg).format("DD/MM/YYYY HH:mm:ss") }</td>
                                <td>{dado.status == '2' ? <a href={`../../Faturas/${dado.id}`}>
                                <span className="label label-success" style={{padding: '10px', fontWeight: 'bold', fontSize: '0.8rem'}}>PAGAR</span>
                                    
                                </a> : '-'}</td>
                                
                            </tr>
                        })}
                       
                        
                        </tbody>
                        
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>  
                
   
  

</div>

<center>
    <br/>
    <button class="btn btn-primary" onClick={Voltar} type="button" name="nova_consulta" id="nova_consulta">Voltar</button>
    <br/><br/><br/><br/>
</center>
</div></div>);
}

export default Resultado;
